import { render, staticRenderFns } from "./modal-edit-material.vue?vue&type=template&id=72176f49&scoped=true&"
import script from "./modal-edit-material.vue?vue&type=script&lang=js&"
export * from "./modal-edit-material.vue?vue&type=script&lang=js&"
import style0 from "./modal-edit-material.vue?vue&type=style&index=0&id=72176f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72176f49",
  null
  
)

export default component.exports